<div>
  <div class="{{data?.class}}">
    {{data.msg}}
  </div>
  <div class="btn-basket">
    <button class="mat-focus-indicator mat-raised-button mat-button-base mat-primary" mat-dialog-close
      [hidden]="data.type==='hideCancel'">Cancel</button>
    <button class="mat-focus-indicator mat-raised-button mat-button-base mat-primary" [mat-dialog-close]="true"
      (click)="closeDialog()">Ok</button>
  </div>
</div>